import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommissionAdjustment, CommissionCreditAdjustDisposition, TransitSchema } from 'src/app/model/other-catalogs-models';

@Injectable({
  providedIn: 'root'
})
export class CommissionSalePromotionsService {
  private url: string;

  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  getListSalePromotions = () => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListSalePromotions`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListCatRegions = () => {
    return this.http.get(`${this.url}/CatGoalRegion/List`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListCatStatesByRegion = (regions: number[]) => {
    return this.http.post(`${this.url}/CatGoalState/ListByRegion`, regions)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListSalePromotionsLog = () => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListSalePromotionsLog`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListEmployeeJobs = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListEmployeeJobs?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListBusinessProducts = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListBusinessProducts?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListFinancingTypes = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListFinancingTypes?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListPaymentTerms = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListPaymentTerms?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListAfiliates = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListAfiliates?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }


  getListFinancing = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListFinancing?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListRegions = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListRegions?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getListStates = (commissionSaleId: number) => {
    return this.http.get(`${this.url}/CommissionSalePromotion/ListStates?commissionSaleId=${commissionSaleId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  updateStatus = (request: any) => {
    return this.http.post(`${this.url}/CommissionSalePromotion/UpdateStatus`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  validate = (request: any) => {
    return this.http.post(`${this.url}/CommissionSalePromotion/ValidateSalePromotion`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  save = (request: any) => {
    return this.http.post(`${this.url}/CommissionSalePromotion/SaveUpdate`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  saveConfigsAsync = (request: any) => {
    return this.http.post(`${this.url}/CommissionSalePromotion/saveOfferConfigurationsAsync`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  delete = (request: any) => {
    return this.http.post(`${this.url}/CommissionSalePromotion/Delete`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getStatusSchema = (SubSchemaHeader: number) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getStatusSchema?SubSchemaHeader=${SubSchemaHeader}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  updateStatusSchema = (SubSchemaHeader: number, activeId: number) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/updateStatusSchema?SubSchemaHeader=${SubSchemaHeader}&activeId=${activeId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getValidateSchema = (SubSchemaHeader: number) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getValidateSchema?SubSchemaHeader=${SubSchemaHeader}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getConfiguratedSchema = (SubSchemaHeader: number) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getConfiguratedSchema?SubSchemaHeader=${SubSchemaHeader}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  deleteTransitSchema = (SubSchemaId: number) => {
    return this.http.get(`${this.url}/TransitSchema/deleteTransitSchema?SubSchemaId=${SubSchemaId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  viewIfExist = (SubSchemaHeaderId: number) => {
    return this.http.get(`${this.url}/TransitSchema/getIfTransitExist?SubSchemaHeaderId=${SubSchemaHeaderId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  ValidateIfActivate = (SubSchemaHeader: number) => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/validateSchema?SubSchemaHeader=${SubSchemaHeader}`)
      .pipe(
        map((resp: any) => resp)
      );
  }


  getTansitSchemaOld = (SubSchemaId: number) => {
    return this.http.get(`${this.url}/TransitSchema/getTransitOld?SubSchemaHeaderId=${SubSchemaId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  restoreTransitSchema = (transitDTO: TransitSchema[]) => {

    console.error(transitDTO)
    return this.http.post(`${this.url}/TransitSchema/restoreTransit`, transitDTO)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getAdjustments = () => {

    return this.http.get(`${this.url}/CommissionAdjustment/ListAllAdjust`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getAdjustmentsCommission = () => {

    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getCommissionAdjustDisposition`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getAdjustmentsPartialCommission = (idEmpleado: string) => {

    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/GetCommissionPartialRelease?idEmpleado=${idEmpleado}`)
      .pipe(
        map((resp: any) => resp)
      );
  }


  updateCommissionRelease = (request: CommissionAdjustment) => {

    console.warn(request)
    return this.http.post(`${this.url}/CommissionAdjustment/updateCommissionRelease`, request)
      .pipe(
        map((resp: any) => resp)
      );
  }

  GetCommissionDispositionResume() {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/CommissionGenerated`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  GetCommissionDispositionDetail(payload: {
    fechaCobroInicio: string,
    fechaCobroFin: string,
    fechaCobro: string,
    fechaEjecucion: string,
    sessionId: string,
    userId: number
  }) {
    console.log(`${this.url}/CommissionProductEmployeeJobWH/GetCommissionDispositionDetail`, payload);
    return this.http.post(`${this.url}/CommissionProductEmployeeJobWH/GetCommissionDispositionDetail`, payload)
      .pipe(
        map((resp: any) => resp)
      );
  }

  SetCommissionDispositionDetail = (claveEmpleadoDispersion: string, comisionTotal: number, ajusteComision: number, comisionFinal: number, userCreate: number, action: number, Nota: string) => {

    console.log(`${this.url}/CommissionProductEmployeeJobWH/SetCommissionAdjustDisposition?ClaveEmpleadoDispersion=${claveEmpleadoDispersion}&comisionTotal=${comisionTotal}&ajusteComision=${ajusteComision}&comisionFinal=${comisionFinal}&action=${action}&userCreate=${userCreate}&Nota=${Nota}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/SetCommissionAdjustDisposition?ClaveEmpleadoDispersion=${claveEmpleadoDispersion}&comisionTotal=${comisionTotal}&ajusteComision=${ajusteComision}&comisionFinal=${comisionFinal}&action=${action}&userCreate=${userCreate}&Nota=${Nota}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  saveCreditAdjust = (lista: CommissionCreditAdjustDisposition[]) => {
    return this.http.post(`${this.url}/CommissionProductEmployeeJobWH/addAdjustCredits`, lista)
      .pipe(
        map((resp: any) => resp)
      );
  }

  SendCaneDisposition = (payload: {
    fechaInicio: string,
    fechaFin: string,
    fechaCobro: string,
    fechaEjecucion: string,
    sessionId: string,
    userId: number
  }) => {
    console.log(`${this.url}/CommissionCane/sendCane`, payload);
    return this.http.post(`${this.url}/CommissionCane/sendCane`, payload)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getAdjustmentsByKEy = (claveDispersion: string) => {

    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getAdjustCredits?claveDispersion=${claveDispersion}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  GetBPartner = (idempleado: string) => {

    console.log(`${this.url}/CommissionProductEmployeeJobWH/getbiplantillaempleados?idempleado=${idempleado}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/getbiplantillaempleados?idempleado=${idempleado}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  GetAdjustmentAvalible = (idempleado: string) => {

    console.log(`${this.url}/CommissionAdjustment/CommissionAdjustmentAvalible?idEmpleado=${idempleado}`)
    return this.http.get(`${this.url}/CommissionAdjustment/CommissionAdjustmentAvalible?idEmpleado=${idempleado}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  partialAdjustmentSet = (iCreditId: string, AmountToFree: number) => {

    console.log(`${this.url}/CommissionAdjustment/PartialAdjustmentFree?iCreditId=${iCreditId}&AmountToFree=${AmountToFree}`)
    return this.http.get(`${this.url}/CommissionAdjustment/PartialAdjustmentFree?iCreditId=${iCreditId}&AmountToFree=${AmountToFree}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  releaseCommissionAdjustDisposition = (claveEmpleadoDispersion: string, status: number) => {

    console.log(`${this.url}/CommissionProductEmployeeJobWH/releaseCommissionAdjustDisposition?claveEmpleadoDispersion=${claveEmpleadoDispersion}&status=${status}`)
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/releaseCommissionAdjustDisposition?claveEmpleadoDispersion=${claveEmpleadoDispersion}&status=${status}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

}
